import { c as _c } from "react/compiler-runtime";
import { forwardRef } from 'react';
const MaxRows = (t0, ref) => {
    const $ = _c(8);
    const { maxRows, skeleton } = t0;
    let t1;
    if ($[0] !== maxRows) {
        t1 = new Array(maxRows).fill("").map(_temp);
        $[0] = maxRows;
        $[1] = t1;
    }
    else {
        t1 = $[1];
    }
    let t2;
    if ($[2] !== t1) {
        t2 = <>{t1}</>;
        $[2] = t1;
        $[3] = t2;
    }
    else {
        t2 = $[3];
    }
    const maxRowsSpanContent = t2;
    const t3 = skeleton ? "inline-block w-full" : "absolute left-0 top-0 invisible";
    let t4;
    if ($[4] !== maxRowsSpanContent || $[5] !== ref || $[6] !== t3) {
        t4 = <span ref={ref} className={t3}>{maxRowsSpanContent}</span>;
        $[4] = maxRowsSpanContent;
        $[5] = ref;
        $[6] = t3;
        $[7] = t4;
    }
    else {
        t4 = $[7];
    }
    return t4;
};
export default forwardRef(MaxRows);
function _temp(item, index) {
    return <span key={index} className="relative block w-full last:w-3/4"><br /><span className="absolute block bottom-0 w-full h-2/3 skeleton "/></span>;
}
